<template>
  <section class="signup-step-container pb-5 mb-5">
    <div class="row justify-content-center">
      <div class="wizard">
        <div class="wizard-inner">
          <div class="connecting-line"></div>
          <ul class="nav nav-tabs" role="tablist">
            <li v-for="(value, key, index) in breadcrumb" :key="key" :class="{ active: isActive(key) }">
              <a>
                <span class="round-tab">{{ isCompleted(key) ? '✓' : index + 1 }}</span>
                <i>{{ value }}</i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    classes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      breadcrumb: {
        menu: '予約内容',
        booking_time: '予約日時',
        confirm: '予約者情報',
        completed: '内容確認'
      }
    };
  },
  methods: {
    isActive(key) {
      return this.classes[key];
    },
    isCompleted(key) {
      const keys = Object.keys(this.breadcrumb);
      const activeIndex = keys.findIndex(k => this.classes[k]);
      const currentIndex = keys.findIndex(k => k === key);
      return currentIndex < activeIndex;
    }
  }
};
</script>

<style scoped>
</style>